import React, { useState } from "react";
import Nav from "./Nav";

const Header = () => {
  const [isBurgerOn, setIsBurger] = useState(false);

  const handleImgBurger = () => {
    isBurgerOn ? setIsBurger(false) : setIsBurger(true);
  };
  return (
    <header className="header-container">
      <div className="header-content wrapper">
        <img src="./assets/shared/logo.svg" alt="logo" id="logo" />
        <button onClick={() => handleImgBurger()} id="burger">
          <img
            src={
              isBurgerOn
                ? "./assets/shared/icon-close.svg"
                : "./assets/shared/icon-hamburger.svg"
            }
            alt=""
          />
        </button>
        <Nav isBurger={isBurgerOn} />
      </div>
    </header>
  );
};

export default Header;
